import React from 'react';
import styled from 'styled-components';
import Surface from '../components/Surface';
import { Heading, Body, Label, Accent } from '../components/Typography';

const PageWrapper = styled(Surface).attrs({ tone: 'base' })`
  padding: 4rem 2rem;

  @media (max-width: 768px) {
    padding: 2.5rem 1.5rem;
  }
`;

const Inner = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const PageLabel = styled(Label)`
  display: block;
  color: #a0412d;
  margin-bottom: 0.75rem;
`;

const PageTitle = styled(Heading)`
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 800;
  margin-bottom: 2.5rem;
`;

const MediaList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const MediaItem = styled(Surface).attrs({ tone: 'raised' })`
  padding: 1.25rem 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 20px 40px rgba(56, 49, 45, 0.05);
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 24px 48px rgba(56, 49, 45, 0.1);
  }
`;

const MediaLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  text-decoration: none;
  color: inherit;
`;

const MediaTitle = styled.p`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  color: #38312d;
  margin-bottom: 0.35rem;
  transition: color 0.2s ease;

  ${MediaLink}:hover & {
    color: #a0412d;
  }
`;

const MediaMeta = styled.span`
  display: block;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #8b6f63;
`;

const MediaContent = styled.span`
  min-width: 0;
`;

const MediaArrow = styled.span`
  font-size: 1rem;
  color: #a0412d;
  flex-shrink: 0;
  transition: transform 0.2s ease;

  ${MediaLink}:hover & {
    transform: translateX(3px);
  }
`;

const EmptyState = styled(Body)`
  color: #665d58;
  font-style: italic;
`;

const articles = [
  {
    title: 'Genesis Energy launches new platform via Bastion Shine',
    publication: 'StopPress',
    date: 'June 7, 2022',
    href: 'https://stoppress.co.nz/news/genesis-energy-launches-new-platform-via-bastion-shine/',
  },
  {
    title: 'Will the family in the Genesis ad become the modern-day anchor whanau',
    publication: 'Stuff',
    date: 'July 2022',
    href: 'https://www.stuff.co.nz/entertainment/tv-radio/300640755/will-the-family-in-the-genesis-ad-become-the-modern-day-anchor-whnau',
  },
  {
    title: 'Genesis Energy releases latest episode in creative platform',
    publication: 'StopPress',
    date: 'November 4, 2022',
    href: 'https://stoppress.co.nz/news/genesis-energy-releases-latest-episode-in-creative-platform/',
  },
  {
    title: 'Does your brand have character?',
    publication: 'NZ Marketing Magazine',
    date: 'November 16, 2022',
    href: 'https://nzmarketingmag.co.nz/does-your-brand-have-character/',
  },
  {
    title: 'Genesis energises future innovators with new work via Bastion Shine',
    publication: 'StopPress',
    date: 'October 13, 2023',
    href: 'https://stoppress.co.nz/news/genesis-energises-future-innovators-with-new-work-via-bastion-shine/',
  },
  {
    title: 'Genesis turns up the heat for Kiwis this winter',
    publication: 'M+AD Daily',
    date: 'April 29, 2024',
    href: 'https://www.mad-daily.com/genesis-warms-up-kiwis/',
  },
  {
    title: 'Not much change, but a lot of differences',
    publication: 'NZ Marketing Magazine',
    date: 'August 28, 2024',
    href: 'https://nzmarketingmag.co.nz/not-much-change-but-a-lot-of-differences/',
  },
  {
    title: "TRA uncovers Kiwis' most-loved ad campaigns",
    publication: 'StopPress',
    date: 'November 19, 2024',
    href: 'https://stoppress.co.nz/news/tra-uncovers-kiwis-most-loved-ad-campaigns/',
  },
  {
    title: "Emotion sells: TRA reveals NZ's favourite ads for June",
    publication: 'StopPress',
    date: 'July 15, 2025',
    href: 'https://stoppress.co.nz/news/emotion-sells-tra-reveals-nzs-favourite-ads-for-june/',
  },
];

const InTheMedia = () => (
  <PageWrapper>
    <Inner>
      <PageLabel>Press</PageLabel>
      <PageTitle>In the <Accent>Media.</Accent></PageTitle>

      {articles.length > 0 ? (
        <MediaList>
          {articles.map(({ title, publication, date, href }) => (
            <MediaItem key={href}>
              <MediaLink href={href} target="_blank" rel="noopener noreferrer">
                <MediaContent>
                  <MediaTitle>{title}</MediaTitle>
                  <MediaMeta>{publication} / {date}</MediaMeta>
                </MediaContent>
                <MediaArrow>→</MediaArrow>
              </MediaLink>
            </MediaItem>
          ))}
        </MediaList>
      ) : (
        <EmptyState>Media coverage will be added here as it comes in.</EmptyState>
      )}
    </Inner>
  </PageWrapper>
);

export default InTheMedia;
